import React, { useState, useEffect } from "react";
import { VscAccount } from "react-icons/vsc";
import { useParams } from "react-router-dom";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { TbLoader } from "react-icons/tb";
import { FiTrash2, FiEdit } from "react-icons/fi";
import MyTextArea from "../../../../helpers/MyTextArea";
import * as Yup from "yup";
import Swal from "sweetalert2";

import { createMessageInNote, getAllMessage, deleteMessageInNote } from "../../../../helpers/Api"
import ComentariosReply from "./ComentariosReply";
import EditComment from "./EditComment/EditComment";

const Comentarios = () => {

    // STATES
    const params = useParams();
    const token = localStorage.getItem('token');
    const role = localStorage.getItem('role');
    const [messagesPosted, setMessagesPosted] = useState([]);

    const [modalIsOpen, setIsOpen] = useState(false);

    const [loading, setLoading] = useState(true);
    const [loadingComments, setLoadingComments] = useState(false);
    const [indexResponse, setIndexResponse] = useState("");
    const [childrenReply, setChildreReply] = useState("");
    const [query, setQuery] = useState(0);


      //PAGINATION
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const itemOffset = 0;
    const [pageCount, setPageCount] = useState(0);
    
  
    let initialValues = {
      mensaje: "",
      mensaje_padre_id: null,
    };

  useEffect(() => {
    handlerGetMessage();
    setIndexResponse(null);
  }, [query, itemsPerPage]);


     //modals
  const openModal = () => {
    setIsOpen(true);
    };
    const closeModal = () => {
    setIsOpen(false);
    };


  const handlerPostMessage = async (values, setSubmitting, resetForm) => {
    try {
      const response = await createMessageInNote(
        params.id,
        token,
        values,
      );
      if (response) {
        setQuery(query + 1);
        setPageCount(response.count);
        setSubmitting(false);
      }
    } catch (error) {
      Swal.fire("Oops", "Ha surgido un problema al postear mensaje", "error");
    } finally {
      resetForm();
    }
  };

    const handlerBubbleReply = (value, index) => {
    if (value) {
      setIndexResponse(index);
      setChildreReply(value.id);
    }
  };
 

  const handlerGetMessage = async () => {
    try {
      const response = await getAllMessage(
        params.id,
        itemsPerPage, 
        itemOffset,
        token,
      );
      if (response) {
        setMessagesPosted(response.results)
        setPageCount(response.count)

      }
    } catch (error) {
    } finally {
      setLoading(false);
      setLoadingComments(false);
    }
  }


  const handlerDeleteMessage = async (idMessage) => {
    Swal.fire({
      title: "¿Estás seguro de eliminar el mensaje?",
      text: "Una vez eliminado, no podrás recuperar este mensaje",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, eliminar!",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await deleteMessageInNote(params.id, idMessage, token);
          if (!response) {
            Swal.fire("Exito", "El mensaje ha sido borrado exitosamente", "success");
            setQuery(query + 1);
          }
        } catch (error) {
          Swal.fire(
            "Oops",
            "Ha surgido un problema al eliminar el contenedor",
            "error"
          );
        }
      }
    });
  };

  const handlerLoadingComments = () => {
    setLoadingComments(true)
    setItemsPerPage(itemsPerPage + 10)
  }



  return (
    <div className="row" style={{height: 'auto'}}>
      {/* <h6 className='detalle_operacion_label_title'>Sección comentarios</h6>    */}
      <Formik
        enableReinitialize="true"
        initialValues={initialValues}
        validationSchema={Yup.object().shape({
          // numero_cuenta: Yup.string().required("Campo requerido"),
          // nombre_banco: Yup.string().required("Campo requerido")
        })}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          handlerPostMessage(values, setSubmitting, resetForm);
        }}
      >
        {(props) => (
          <Form>
            <div className="col-12">
              <label for="formGroupExampleInput" className="form-label">
              Escribir comentarios
              </label>
              <MyTextArea
                type="text-area"
                name="mensaje"
                className="form-control"
                placeholder="Agregar comentarios"
              />
            </div>
            <div className="col-12 mt-3 d-flex flex-row-reverse">
            <button type="submit" className="btn btn-primary">
              {!props.isSubmitting ?  'Enviar' : <TbLoader color={'rgba(255, 255, 255, 1)'} size={'1.4rem'} className="loader_login_button" /> } 
            </button>
            </div>
          </Form>
        )}
      </Formik>
    
      { loading ? (
        <div className="d-flex justify-content-center" style={{marginTop: '4rem'}}>
              <TbLoader color={'rgb(10, 132, 254)'} className="loader" size={'3rem'}/>
          </div>
      ) : (
     <>
      <div className="col-12 mt-4">
      { messagesPosted.map((value, index) => (
        <>
        <EditComment 
        modalIsOpen={modalIsOpen} 
        closeModal={closeModal}
        idSolicitud={params.id}
        idMessage={value.id}
        data={value}
        query={query}
        setQuery={setQuery}
        token={token}
        /> 
    
        <div className="row">
          <div className="col-12 d-flex flex-row-reverse">
            <div className={ role !== value.usuario_creador.role ? "detalle_operacion_reply_post" : "detalle_operacion_answer_post  mt-5"} key={index}>
            { role === value.usuario_creador.role &&
              <div className="row d-flex flex-row-reverse">
                <div className="col-1 d-flex justify-content-start">
                <button className="btn" onClick={openModal} style={{padding : 0}} >
                   <FiEdit size={'1.1rem'} />
                </button>
                </div>
                <div className="col-1 d-flex justify-content-end" >
                  <button className="btn" onClick={() => handlerDeleteMessage(value.id)}>
                    <FiTrash2 size={'1.1rem'}  style={{ color: "#F34949" }}/>
                  </button>
                </div>
              </div>
            }
              <div className="detalle_operacion_profile d-flex align-items-start">
                <VscAccount size={'1.2rem'} />    
                <p className="detalle_operacion_profile">{value.usuario_creador?.username}</p>
                <p className="detalle_operacion_date">{value.fecha_creacion}</p>
              </div>
              <div className="detalle_operacion_comments">
                <p key={index}>
                  {value.mensaje}
                </p>
              </div>
          </div> 
        </div>
        </div>
   
       
        { value.usuario_creador.role !== role ?
          <div className="col-12 d-flex flex-row-reverse" style={{paddingRight: '20px'}}>
            <button  
            onClick={() => handlerBubbleReply(value, index)}   
            className="btn">
            Responder
          </button>
          </div>
          :
          <div className="col-12 d-flex flex-row-reverse" style={{paddingBottom: '30px'}}>
          </div>
        }
           { indexResponse === index && ( 
            <ComentariosReply 
            idSolicitud={value.solicitud_id}  
            childrenReply={childrenReply} 
            token={token}
            setQuery={setQuery}
            query={query}
            /> 
            )}
          </>
        ))}
      </div> 
      <div className="row">
        <div className="col-12 d-flex justify-content-center">
        {  itemsPerPage >= pageCount ? <p style={{fontFamily: 'Inconsolata', paddingTop: '40px'}}>No hay más comentarios</p> :
           loadingComments ? 
           <button className="btn btn-outline-secondary">
              cargando... 
           </button> :
           <button className="btn btn-outline-secondary" onClick={() =>  handlerLoadingComments()}>
              Cargar más mensajes
           </button>
        }
        </div>
      </div>      
      </>
      )} 
     
    </div>
    
  );
};


export default Comentarios;
